import { log } from "console";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// ✅ Get PlaylistType
export const getPlaylistType = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EDETAILING.PLAYLIST_TYPE,
    { params: params }
  );
  console.log(
    "🚀 ~ file: EdetailingRepository.ts ~ line 22 ~ fetchPlaylisttype ~ response",
    response.data.data.data
  );
  return response?.data?.data?.data;
};

export const getPresentationsDopdown = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EDETAILING.ED_PRESENTATION_DROPDOWN_DATA,
    { params: params }
  );
  const rowData = await response?.data;
  // console.log("ED_PRESENTATION_DROPDOWN_DATA",response?.data?.data?.data);

  const formatedData = Array.isArray(rowData.data?.data)
    ? rowData.data.data.map((item: any) => ({
        id: item.PresentationId,
        label: item.PresentationName,
      }))
    : [];

  return { rowData, formatedData };
  //  console.log('formatedData==>',formatedData);
};

// ✅ Add PlaylistType
export const addPlaylistType = async (body: { PlaylistTypeName: string }) => {
  return axiosInstance.post(API_ENDPOINTS.EDETAILING.ADD_PLAYLIST_TYPE, body);
};

//Update PlaylistType
export const updatePlaylistType = async (
  id: number,
  body: { PlaylistTypeName: string }
) => {
  console.log(`id---${id}------body:${JSON.stringify(body)}`);
  // return axiosInstance.put(`${API_ENDPOINTS.EDETAILING.UPDATE_PLAYLIST_TYPE.replace("{id}", id.toString())}`, body);
  return axiosInstance.put(
    `${API_ENDPOINTS.EDETAILING.UPDATE_PLAYLIST_TYPE}/${id}`,
    body
  );
};

////////////////PRESENTATIONS API////////////////////////

// ✅ Get Presentations
export const getPresentations = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EDETAILING.ED_PRESENTATIONS,
    { params: params }
  );
  console.log(
    "🚀 ~ file: EdetailingRepository.ts ~ line 22 ~ fetchPlaylisttype ~ response",
    response.data.data
  );
  return response?.data?.data;
};

// ✅ Add EdPresentations
export const addEdPresentations = async (body: {
  BrandId: string;
  PresentationTypeName: string;
  PresentationName: string;
  PresentationZipUrl: string;
  PresentationVersionId: string;
  PageCount: string;
  PresentationReleaseDate: string;
  MediaUrl: string;
  PresentationLanguageId: string;
  PresentationMedia: any;
}) => {
  return axiosInstance.post(
    API_ENDPOINTS.EDETAILING.ADD_ED_PRESENTATIONS,
    body
  );
};
// ✅ Update EdPresentations
export const updateEdPresentations = async (
  id: any,
  body: {
    BrandId: string;
    PresentationTypeName: string;
    PresentationName: string;
    PresentationZipUrl: string;
    PresentationVersionId: string;
    PageCount: string;
    PresentationReleaseDate: string;
    MediaUrl: string;
    PresentationLanguageId: string;
    PresentationMedia: any;
  }
) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.EDETAILING.UPDATE_ED_PRESENTATIONS}/${id}`,
    body
  );
};

// ✅ Get Playlist
export const getPlaylist = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.EDETAILING.PLAYLIST, {
    params: params,
  });
  const rowData = response?.data.data;
  console.log("rowData", rowData);
  return { rowData };
};

//Add Playlist
export const addPlaylist = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.EDETAILING.ADD_PLAYLIST, body);
};

//Update Playlist
export const updatePlaylist = async (body: any) => {
  return axiosInstance.put(API_ENDPOINTS.EDETAILING.UPDATE_PLAYLIST, body);
};

// ------- fetch getBrands -----------
export const getBrands = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.EDETAILING.BRANDS);
  let dt = response?.data?.data;
  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    console.log(
      "🚀 ~ file: EdetailingRepository.ts ~ line 21 ~ getBrands ~ response",
      data
    );
    return { data };
  }
  return { data: [] };
};
// ------- fetch getPresentationType -----------
export const getPresentationType = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EDETAILING.PRESENTATION_TYPE
  );
  let dt = response?.data?.data;

  console.log("response?.data?---------------------->", response?.data);

  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    console.log(
      "🚀 ~ file: EdetailingRepository.ts ~ line 21 ~ getBrands ~ response",
      data
    );
    return { data };
  }
  return { data: [] };
};
// ------- fetch getLanguages -----------
export const getLanguages = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.EDETAILING.LANGUAGES);
  let dt = response?.data?.data;
  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    console.log(
      "🚀 ~ file: EdetailingRepository.ts ~ line 21 ~ getLanguages ~ response",
      data
    );
    return { data };
  }
  return { data: [] };
};
export const getOutletTags = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EDETAILING.OUTLET_TAGS
  );
  let dt = response?.data?.data;

  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, item: any) => {
      arr.push({ id: item, label: dt[item] });
      return arr;
    }, []);
    console.log(
      "🚀 ~ file: getOutletTags.ts ~ line 21 ~ getOutletTags ~ response",
      data
    );
    return { data };
  }
  return { data: [] };
};

// ✅ Upload Media
export const handleMedia = async (file: File) => {
  const reader = new FileReader();

  return new Promise<string>((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64Data = reader.result?.toString().split(",")[1];
      console.log("base64Data", base64Data);
      let body = {
        folder_id: "1",
        media: [base64Data],
      };

      try {
        const response = await axiosInstance.post(
          API_ENDPOINTS.MEDIA.UPLOAD_MEDIA_BASE64,
          body
        );
        console.log("response", response);

        if (response?.data?.data[0]) {
          console.log(
            "Media uploaded successfully. Media ID:",
            response?.data?.data[0]
          );
          resolve(response?.data?.data[0]);
        } else {
          reject(new Error("Failed to get mediaId"));
        }
      } catch (error) {
        console.error("Media upload failed:", error);
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };
  });
};

// import axios from "axios";
// import { API_ENDPOINTS, axiosInstance } from "./yourApiConfig"; // adjust your imports

export const handleMediaAndFile = async (file: File): Promise<string> => {
  // ✅ If file is image, use base64 API
  if (file.type.startsWith("image/")) {
    const base64Data = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve(reader.result?.toString().split(",")[1] || "");
      reader.onerror = () => reject(new Error("Failed to read image file"));
    });

    const body = {
      folder_id: "1",
      media: [base64Data],
    };

    const response = await axiosInstance.post(
      API_ENDPOINTS.MEDIA.UPLOAD_MEDIA_BASE64,
      body
    );

    if (response?.data?.data?.[0]) {
      return response.data.data[0]; // mediaId
    } else {
      throw new Error("Failed to get mediaId");
    }
  }

  // ✅ If file is PDF (or other non-image), use multipart/form-data API
  const AppToken = localStorage.getItem("Apptoken");
  const formData = new FormData();
  formData.append("mediafile", file);

  const response = await axios.post(
    "https://tspc-development.truesales.in/api/uploadFile",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        apptoken: AppToken, // 🔑 make dynamic if needed
      },
    }
  );

  console.log(
    "🚀 ~ EdetailingRepository.tsx:296 ~ handleMediaAndFile ~ response:",
    response?.data?.data?.data
  );

  if (response?.data?.data?.data) {
    return response?.data?.data?.data;
  } else {
    throw new Error("Failed to get PDF mediaId");
  }
};
